import { useRouter } from 'next/router'
import { useMemo } from 'react'

/**
 * Returns object of query params
 * @param {Array} deps - array of dependencies
 * @returns {Object} object contains query params with values
 */

export default function usePartialQuery(deps) {
  const router = useRouter()

  const memoized = useMemo(
    () => {
      const query = {}
      deps.forEach(dep => {
        if (router.query[dep]) {
          query[dep] = router.query[dep]
        }
      })
      return query
    },
    deps.map(dep => router.query[dep]),
  )

  return memoized
}
